import { c as _c } from "react/compiler-runtime";
import { RichTagsFunction, useTranslations } from 'next-intl';
export type OnAccepted = () => void;
export const GuidelinesStepUnlock = t0 => {
  const $ = _c(42);
  const {
    onAccepted
  } = t0;
  const t = useTranslations("GuidelineForm");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = _temp;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== t) {
    const commonValues = {
      strong: t1
    };
    t9 = "m-10";
    t6 = "my-2 list-decimal";
    let t10;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <br />;
      $[10] = t10;
    } else {
      t10 = $[10];
    }
    t7 = <li className="my-2">{t.rich("step1_title", commonValues)}{t10}{t("step1_description")}<ul className="list-inside list-disc"><li>{t.rich("step1_option1", commonValues)}</li><li>{t.rich("step1_option2", commonValues)}</li><li>{t.rich("step1_option3", commonValues)}</li></ul>{t.rich("step1_note", commonValues)}</li>;
    let t11;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <br />;
      $[11] = t11;
    } else {
      t11 = $[11];
    }
    t8 = <li className="my-2">{t.rich("step2_title", commonValues)}{t11}{t("step2_description")}</li>;
    t4 = "my-2";
    t5 = t.rich("step3_title_unlock", commonValues);
    t3 = "list-inside list-disc";
    t2 = t.rich("step3_description_unlock", commonValues);
    $[1] = t;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[12] !== t2) {
    t10 = <li>{t2}</li>;
    $[12] = t2;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t3) {
    t11 = <ul className={t3}>{t10}</ul>;
    $[14] = t10;
    $[15] = t3;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t4 || $[19] !== t5) {
    t12 = <li className={t4}>{t5}{t11}</li>;
    $[17] = t11;
    $[18] = t4;
    $[19] = t5;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t13 = <ol className={t6}>{t7}{t8}{t12}</ol>;
    $[21] = t12;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t) {
    t14 = t("support");
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14) {
    t15 = <p className="my-2">{t14}</p>;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== onAccepted) {
    t16 = () => onAccepted();
    $[30] = onAccepted;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t) {
    t17 = t("accept");
    $[32] = t;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t16 || $[35] !== t17) {
    t18 = <div className="flex flex-row justify-end p-2"><button className="btn btn-primary" onClick={t16}>{t17}</button></div>;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t13 || $[38] !== t15 || $[39] !== t18 || $[40] !== t9) {
    t19 = <><div className={t9}>{t13}{t15}{t18}</div></>;
    $[37] = t13;
    $[38] = t15;
    $[39] = t18;
    $[40] = t9;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  return t19;
};
function _temp(chunks) {
  return <strong>{chunks}</strong>;
}